import { BaseResponse } from '@/main/models/common';
import { TypeRegisterStep } from './types';
import { AxiosError } from 'axios';
import {
  getTranslateByFullKey,
  handleGeneralError,
  isNullUndefined
} from '@/main/services/utils';
import { CustomError } from '@/main/services/class/customError';

export function getAllSteps(): TypeRegisterStep[] {
  return [
    'CompanyData',
    'LegalInformation',
    'Contact',
    'Address',
    'Warehouse',
    'DistributionRegion',
    'SupplyConfiguration',
    'Insurers',
    'Summary',
    'Finish'
  ];
}

export function getStepsRegisterSupplier(): TypeRegisterStep[] {
  return [
    'CompanyData',
    'LegalInformation',
    'Contact',
    'Address',
    'Warehouse',
    'DistributionRegion',
    'SupplyConfiguration',
    'Insurers',
    'Summary',
    'Finish'
  ];
}

export function getStepsRegisterBodyshop(): TypeRegisterStep[] {
  return [
    'CompanyData',
    'LegalInformation',
    'Contact',
    'Address',
    'Insurers',
    'Summary',
    'Finish'
  ];
}

export const STEPS_NOT_SHOW_MODAL_EXIT_REGISTRATION: TypeRegisterStep[] = [
  'Finish'
];
export const STEPS_NOT_SHOW_MODAL_BACK_STEP: TypeRegisterStep[] = [
  'Finish',
  'Summary'
];
export const STEPS_NOT_SHOW_STEPPER: TypeRegisterStep[] = ['Finish'];

//#region Handle Errors
export enum ENUM_ERROR_EMAIL {
  CAPTCHA = 'captcha',
  EMAIL = 'email'
}

export function handleAxiosError(error: AxiosError<BaseResponse>) {
  if (
    !isNullUndefined(error.response) &&
    error.response.data.isHideToastNotification
  ) {
    const message = getTranslateByFullKey(
      String(error.response.data.errorMessages[0].key)
    );
    throw new CustomError(message, ENUM_ERROR_EMAIL.EMAIL);
  } else {
    handleGeneralError();
  }
}
export function handleValidationError(error: CustomError) {
  const errorMessage = error.message;
  const errorCode = error.code;

  if (errorCode === ENUM_ERROR_EMAIL.EMAIL) {
    throw new CustomError(errorMessage, ENUM_ERROR_EMAIL.EMAIL);
  }
}

